<template>
  <div>
    <el-dialog top='0px' :visible.sync="dialogVisible" custom-class="side-dialog" width="80%">
      <el-menu :default-active="$route.path" class="el-menu-vertical-demo" router @select="clickmenuItem" @open="handleOpen" @close="handleClose">
        
        <el-menu-item index="/" >
          <svg viewBox="0 0 17 17" style="width: 18px; height: 18px; margin: auto 4px;">
            <path
              d="M11.044 5.588c6.307.633 6.326.672 1.577 5.064 1.375 6.405 1.283 6.482-4.126 3.126-5.408 3.356-5.482 3.28-4.107-3.126-4.767-4.392-4.73-4.43 1.559-5.064 2.548-6.117 2.567-6.117 5.097 0z"
              stroke="#C0952B" fill="#FFD560" fill-rule="evenodd"></path>
          </svg>
          <span slot="title"> Home</span>
        </el-menu-item>
        <el-menu-item index="/cats?type=Massager">
          <i class="el-icon-menu"></i>
          <span slot="title">Massager</span>
        </el-menu-item>
        <el-menu-item index="/cats?type=Beauty">
          <i class="el-icon-menu"></i>
          <span slot="title">Beauty Electronics</span>
        </el-menu-item>
        <el-menu-item index="/cats?type=Home">
          <i class="el-icon-menu"></i>
          <span slot="title">Smart Home</span>
        </el-menu-item>
        <!-- <el-submenu index="6">
          <template slot="title">
            <i class="el-icon-menu"></i>
            <span>Bags</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/cats?type=Bags">Men's Bags</el-menu-item>
            <el-menu-item index="/cats?type=Bags">Women's Bags</el-menu-item>
          </el-menu-item-group>
        </el-submenu> -->
      </el-menu>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'newArrival',
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    show() {
      this.dialogVisible = true
    },
    hide() {
      this.dialogVisible = false
    },
    handleOpen (row1,row2) {
      console.log(row1,row2,)
    },
    clickmenuItem () {
      this.hide()
      this.$emit('refresh')
    },
    handleClose () {},
  }
}
</script>

<style lang="less" scoped>
@media (width < 768px) {
  /deep/.el-dialog__wrapper {
    padding: 0;
  }
  /deep/.el-dialog {
    padding: 0;
    border-radius: 0px;
    height: 100%;
  }
  /deep/.el-dialog__headerbtn {
    top: 12px;
    right: 16px;
    font-size: 20px;
  }
  /deep/.el-dialog__body {
    padding: 10px 0 !important;
  }
}
</style>